// Maps the English messages the Search Groups flow stores or falls back to, to translation keys.
// Backend messages are not listed here; they are shown as the server sent them.
const KEYS = {
  'Your request is awaiting review by the supplier.': 'joinStatus.awaitingReview',
  'Could not check your request status. Please try again.': 'joinStatus.checkFailed',
  'Your request was sent to the supplier.': 'joinStatus.sentFallback',
  'Could not send your request. Please try again.': 'joinStatus.sendFailed',
  'Failed to fetch groups': 'groups.errors.fetch',
  'Failed to search groups': 'groups.errors.search',
  'Your payment is processing. Please do not pay again; your order will appear shortly.': 'cart.processingMessage',
  'We could not confirm your payment status. Check status before paying again.': 'cart.unconfirmed',
  'This checkout can no longer be paid. Use Cancel checkout, then start checkout again.': 'cart.noLongerPayable',
  'Payment failed. Please try again.': 'payment.failed',
  'Your card was not accepted. Check the details and try again.': 'cart.cardRejected',
  'Could not load your cart.': 'cart.loadError',
  'Could not update your cart.': 'cart.updateError',
  'Could not start checkout.': 'cart.startError',
  'Could not cancel your checkout.': 'cart.cancelError',
  'Could not load your orders. Please try again later.': 'orders.loadError',
  'Login failed. Check credentials.': 'messages.loginFailed',
  'Please verify your email before signing in.': 'verify.loginRequired',
  'Invalid credentials': 'messages.invalidCredentials',
  'Password is required.': 'password.required',
  'Cash payment is not offered for a group in your cart. Pay by card instead.': 'cash.notOffered',
  'You have too many open cash orders. Pay or cancel them before starting another.': 'cash.tooMany',
  'The payment deadline has passed, so this order was released.': 'cash.deadlinePassed',
  'This order is no longer awaiting payment.': 'cash.notAwaiting',
  'This order is already paid and cannot be cancelled.': 'cash.alreadyPaid',
  'Only this supplier can confirm cash payment': 'cash.onlySupplier',
  'Cash order not found': 'cash.notFound',
  'Give a reason of at least 10 characters to cancel this order.': 'cancel.reasonTooShort',
  'Preparation has started, so the customer can no longer cancel this order.': 'cancel.preparing',
  'This order can no longer be cancelled.': 'cancel.finished',
  'This order is being created or updated. Try again in a moment.': 'cancel.busy',
  'This order changed while it was being cancelled. Reload and try again.': 'cancel.changed',
  'You cannot cancel this order': 'cancel.forbidden',
  'Order not found': 'cancel.notFound',
  'This refund is not waiting for a settlement, or it was already recorded.': 'cancel.settleNotDue',
  'Give the refund method and a reference': 'cancel.settleMissing',
  'Some orders in this cancellation changed before they could be cancelled. Reload to see their status.': 'cancel.partial',
  'Confirm cash payment before changing this order.': 'cash.confirmFirst',
  'Cash payment must be turned on or off': 'cash.settingInvalid',
  'Cash payment deadline must be 1 to 168 hours': 'cash.deadlineInvalid',
  'Could not confirm cash payment': 'cash.errorConfirm',
  'Could not cancel this order': 'cash.errorCancel',
  'Too many attempts. Try again in a few minutes.': 'messages.tooManyAttempts',
  'Google sign-in could not be verified. Please try again.': 'messages.googleVerifyFailed',
  'This account is already linked to a different Google account.': 'messages.googleLinkConflict',
  'Google sign-in failed. Please try again.': 'messages.googleSignInFailed',
  'Google sign-up failed. Please try again.': 'messages.googleSignUpFailed',
  'Session expired due to inactivity': 'messages.sessionIdle',
  'Your session has expired. Please log in again.': 'messages.sessionExpired',
  'Registration failed.': 'messages.registrationFailed',
  'Server error. Please try again later.': 'messages.serverError',
  'Reset link sent to your email': 'messages.resetLinkSent',
  'Failed to send reset link': 'messages.resetLinkFailed',
  'Invalid or missing reset token': 'messages.resetTokenMissing',
  'Password reset successfully': 'messages.resetDone',
  'Failed to reset password': 'messages.resetFailed',
  'Could not load your profile.': 'messages.profileLoadFailed',
  'Password changed successfully.': 'messages.passwordChanged',
  'Could not change your password.': 'messages.passwordChangeFailed',
  'Choose a JPEG, PNG or WebP image up to 5 MB.': 'messages.photoType',
  'Could not upload your photo.': 'messages.photoFailed',
  'Could not save your language.': 'messages.languageSaveFailed',
  'Could not save your profile.': 'messages.profileSaveFailed',
  'Could not save your review. Please try again.': 'messages.reviewFailed',
  'Image exceeds the 5 MB limit.': 'messages.photoTooLarge',
  'Server upload limit exceeded. Try a smaller image or contact support.': 'messages.photoServerLimit',
  'Upload failed. Please try again.': 'messages.uploadFailed',
  'Google sign-in was not completed. Please try again.': 'messages.googleNotCompleted',
  'Google sign-in is unavailable right now. Please use your password.': 'messages.googleUnavailable',
  'Failed to fetch suppliers. Please try again later.': 'messages.fetchSuppliersFailed',
  'Failed to fetch groups. Please try again later.': 'messages.fetchGroupsFailed',
  'Failed to search groups. Please try again later.': 'messages.searchGroupsFailed',
  'Added to your cart.': 'messages.addedToCart',
  'Could not add to cart.': 'messages.addToCartFailed',
  'There are not enough portions left in this group for that choice.': 'messages.notEnoughBody',
  'This supplier does not offer delivery. Choose Pickup.': 'messages.deliveryNotOffered',
  'Members only': 'messages.membersOnly',
  'Log in to reserve a share': 'messages.loginToReserve',
  'Error': 'messages.titleError',
  'Cart': 'messages.titleCart',
  'Not enough portions': 'messages.titleNotEnough',
  'Registration Successful': 'messages.registrationTitle',
  'Failed to load groups': 'adminGroups.loadError',
  'Group not found': 'viewGroup.notFound',
  'Failed to load group details': 'viewGroup.loadFailed',
};

// The server's inventory limit is one English sentence with a count and a portion size. Only that exact template is
// mapped; the count and portion are read from it and the sentence is rebuilt from translated parts.
const INVENTORY_LIMIT = /^Only (\d+) (full|half|quarter) portions? (?:is|are) available\. You cannot add more\.$/i;

function translateInventoryLimit(t, message) {
  const m = INVENTORY_LIMIT.exec(message || '');
  if (!m) return null;
  const count = Number(m[1]);
  const portion = t(`portions.${m[2].toLowerCase()}`).toLowerCase();
  return t('cart.inventoryLimit', { count, portion });
}

export function translateKnown(t, message) {
  const key = KEYS[message];
  if (key) return t(key);
  return translateInventoryLimit(t, message) ?? message;
}
